module.exports = __webpack_public_path__ + "assets/arrow-down-20dc5c01b324d60d24ccf0598ab2edd7.svg";